module.exports = __webpack_public_path__ + "img/comm-server.fcb8b5db.svg";